import React from 'react';
import { Trans } from 'react-i18next';
import i18n from 'i18n';
import Tip from 'components/Common/Template/Tip';
import PopupJobTitle from './PopupJobTitle';

export const TabJobTitle = () => {
  return (
    <>
      <div className="content">
        <div className="tab img-area jobtitle" />
        <div className="left-wrap">
          <div className="wrapper">
            <div className="large-title">
              <Trans i18nKey="BTY_W_T_POSITION_ADD_T" />
            </div>
          </div>
          <div className="large-text">
            <Trans i18nKey="BTY_W_T_ADD_JOB_LIMIT_20" />
            <div>{i18n.t('BTY_W_T_ADD_JOB_DETAIL')}</div>
          </div>
          <div className="info">
            <i className="ic-info-solid-gray sm" />
            <p className="sub-text">{i18n.t('BTY_W_T_JOBTITLE_NOT_DEL')}</p>
          </div>
        </div>
      </div>
      <Tip subText=<Trans i18nKey="BTY_W_T_JOBTITLE_INFO" /> />

      <PopupJobTitle />
    </>
  );
};

export default TabJobTitle;
